export default __webpack_public_path__ + "static/media/microfone.0771d169.svg";